'use strict';

// Styles — Vite extracts to CSS file automatically in production,
// injects via <style> in dev for instant HMR
import '../scss/main.scss';

// Application bootstrap
import { init } from './app';

init();
